<gl-box #glBox>
  <div class="wrapper">
    <div class="leftContainer">
      @if (chosenType <= 3) {
        <div class="visualization">
          <gl-loading-space-preview
            [height]="184"
            [project]="project"
            [loadingSpaceType]="loadingSpace"
            [width]="230"
            (clicked)="onPreviewClicked($event)"
          ></gl-loading-space-preview>
        </div>
      }
      @if (chosenType === 4) {
        <div class="visualization">
          <gl-air-container-preview [loadingSpace]="loadingSpace"></gl-air-container-preview>
        </div>
      }

      @if (chosenType !== 3 && project.workSpaces.length < 2) {
        <div
          class="multistop"
          (click)="openMultistop()"
          >
          <gl-icon class="multistopIcon" name="multistop"></gl-icon>
          {{ 'points_along_route' | translate }}
        </div>
      }

      <gl-slide-toggle (click)="showTabs()">{{ 'more_options' | translate }}</gl-slide-toggle>
    </div>

    <div>
      <form [formGroup]="loadingSpaceSelectForm" class="selectForm">
        <gl-select placeholder="change" formControlName="loadingSpaceSelect">
          @for (loadingSpace of loadingSpaces; track loadingSpace) {
            <gl-option
              [value]="loadingSpace"
              [label]="loadingSpace.name"
            ></gl-option>
          }
        </gl-select>
      </form>

      @if (chosenType === 1) {
        <gl-loading-space-dimensions
          #dimensions
          (formData)="onFormData($event, 'dimensions')"
          (submitEmitter)="submit($event)"
          [chosenLoadingSpace]="chosenLoadingSpace"
          [loadingSpace]="loadingSpace"
          [isEdit]="isEdit"
          [typeLoadingSpace]="chosenType"
          [changeType]="true"
          (deleteLoadingSpace)="deleteLoadingSpace()"
          [hideDelete]="hideDelete"
          [savedStops]="savedStops"
          [initialStops]="initialStops"
        ></gl-loading-space-dimensions>
      }
      @if (chosenType === 2) {
        <gl-loading-space-dimensions
          #dimensions
          (formData)="onFormData($event, 'dimensions')"
          (submitEmitter)="submit($event)"
          [chosenLoadingSpace]="chosenLoadingSpace"
          [loadingSpace]="loadingSpace"
          [isEdit]="isEdit"
          [typeLoadingSpace]="chosenType"
          [changeType]="true"
          (deleteLoadingSpace)="deleteLoadingSpace()"
          [hideDelete]="hideDelete"
          [savedStops]="savedStops"
          [initialStops]="initialStops"
        ></gl-loading-space-dimensions>
      }
      @if (chosenType === 3) {
        <gl-loading-space-pallet-dimensions
          #palletdimensions
          (formData)="onFormData($event, 'pallet')"
          (submitEmitter)="submit($event)"
          [chosenLoadingSpace]="chosenLoadingSpace"
          [loadingSpace]="loadingSpace"
          [isEdit]="isEdit"
          [typeLoadingSpace]="chosenType"
          [changeType]="true"
          [dimensionsLocked]="palletDimensionsLocked"
          (deleteLoadingSpace)="deleteLoadingSpace()"
          [hideDelete]="hideDelete"
        ></gl-loading-space-pallet-dimensions>
      }
      @if (chosenType === 4) {
        <gl-loading-space-air-dimensions
          #airdimensions
          (formData)="onFormData($event, 'air')"
          (submitEmitter)="submit($event)"
          [chosenLoadingSpace]="chosenLoadingSpace"
          [loadingSpace]="loadingSpace"
          [isEdit]="isEdit"
          [typeLoadingSpace]="chosenType"
          [changeType]="true"
          (deleteLoadingSpace)="deleteLoadingSpace()"
          [hideDelete]="hideDelete"
          [savedStops]="savedStops"
          [initialStops]="initialStops"
        ></gl-loading-space-air-dimensions>
      }
    </div>
  </div>

  @if (tabsActive) {
    <div class="tabs">
      @if (chosenType <= 2) {
        <div (click)="openTab('set')" [ngClass]="{ active: isTabSet }" class="tab">
          <div class="tabText">{{ 'set' | translate }}</div>
        </div>
        @if (chosenType === 1) {
          <div
            (click)="openTab('axle-loads')"
            [ngClass]="{ active: isTabAxle }"
            class="tab"
            >
            <div class="tabText">{{ 'axle_loads' | translate }}</div>
          </div>
        }
        @if (chosenType === 2) {
          <div
            (click)="openTab('gravity-center')"
            [ngClass]="{ active: isTabGravityCenter }"
            class="tab"
            >
            <div class="tabText">{{ 'gravity_center' | translate }}</div>
          </div>
        }
        @if (chosenType === 1) {
          <div
            (click)="openTab('wheel-arches')"
            [ngClass]="{ active: isTabWheelArches }"
            class="tab"
            >
            <div class="tabText">{{ 'wheel_arches' | translate }}</div>
          </div>
        }
        @if (chosenType <= 3) {
          <div
            (click)="openTab('cooler')"
            [ngClass]="{ active: isTabCooler }"
            class="tab"
            >
            <div class="tabText">{{ 'cooling_unit' | translate }}</div>
          </div>
        }
        @if (chosenType === 2) {
          <div
            (click)="openTab('door-size')"
            [ngClass]="{ active: isTabDoorSize }"
            class="tab"
            >
            <div class="tabText">{{ 'door_size' | translate }}</div>
          </div>
        }
        @if (chosenType === 1) {
          <div
            (click)="openTab('variofloor')"
            [ngClass]="{ active: isTabVarioFloor }"
            class="tab"
            >
            <div class="tabText">{{ 'variofloor' | translate }}</div>
          </div>
        }
      }
      @if (chosenType === 3) {
        <!-- <div
        (click)="openTab('palletStacking')"
        [ngClass]="{ active: isPalletStacking }"
        class="tab"
        >
        <div class="tabText">{{ 'stacking' | translate }}</div>
      </div> -->
      <div
        (click)="openTab('palletVehicleLoading')"
        [ngClass]="{ active: isPalletVehicleLoading }"
        class="tab"
        >
        <div class="tabText">{{ 'vehicle_loading' | translate }}</div>
      </div>
    }
    @if (chosenType === 4) {
      <div
        (click)="openTab('gravity-center')"
        [ngClass]="{ active: isTabGravityCenter }"
        class="tab"
        >
        <div class="tabText">{{ 'gravity_center' | translate }}</div>
      </div>
    }
  </div>
}
@if (isTabSet) {
  <div class="tabContent">
    <gl-loading-space-set
      #set
      (submitEvent)="submitEvent($event, 'Set')"
      [chosenLoadingSpace]="chosenLoadingSpace"
      [isEdit]="isEdit"
      [project]="project"
      [loadingSpace]="loadingSpace"
      [typeLoadingSpace]="chosenType"
    ></gl-loading-space-set>
  </div>
}
@if (isTabWheelArches) {
  <div class="tabContent">
    <gl-loading-space-wheel-arches
      #wheel
      (submitEvent)="submitEvent($event, 'Wheel')"
      [chosenLoadingSpace]="chosenLoadingSpace"
      [isEdit]="isEdit"
      [project]="project"
      [loadingSpace]="loadingSpace"
      [typeLoadingSpace]="chosenType"
    ></gl-loading-space-wheel-arches>
  </div>
}
@if (isTabAxle) {
  <div class="tabContent">
    <gl-loading-space-axle-loads
      #axleLoads
      (scrollDisable)="scrollDisable($event)"
      (submitEmitter)="axlesSave($event)"
      [isEdit]="isEdit"
      [loadForm]="dimensionsComponent?.form"
      [loadingSpace]="loadingSpace"
      [chosenLoadingSpace]="chosenLoadingSpace"
      >
    </gl-loading-space-axle-loads>
  </div>
}
@if (isTabGravityCenter) {
  <div class="tabContent">
    <gl-loading-space-gravity-center
      (submitEvent)="submitEvent($event, 'GravityCenter')"
      [chosenLoadingSpace]="chosenLoadingSpace"
      [isEdit]="isEdit"
      [loadingSpace]="loadingSpace"
      >
    </gl-loading-space-gravity-center>
  </div>
}
@if (isTabCooler) {
  <div class="tabContent">
    <gl-loading-space-cooler
      #cooler
      (submitEvent)="submitEvent($event, 'Cooler')"
      [chosenLoadingSpace]="chosenLoadingSpace"
      [isEdit]="isEdit"
      [project]="project"
      [loadingSpace]="loadingSpace"
      [typeLoadingSpace]="chosenType"
    ></gl-loading-space-cooler>
  </div>
}
@if (isTabDoorSize) {
  <div class="tabContent">
    <gl-loading-space-door-size
      #door
      (submitEvent)="submitEvent($event, 'Door')"
      [chosenLoadingSpace]="chosenLoadingSpace"
      [isEdit]="isEdit"
      [project]="project"
      [loadingSpace]="loadingSpace"
    ></gl-loading-space-door-size>
  </div>
}
@if (isTabVarioFloor) {
  <div class="tabContent">
    <gl-loading-space-vario-floor
      #varioFloor
      (submitEvent)="submitEvent($event, 'VarioFloor')"
      [chosenLoadingSpace]="chosenLoadingSpace"
      [isEdit]="isEdit"
      [project]="project"
      [loadingSpace]="loadingSpace"
      [typeLoadingSpace]="chosenType"
    ></gl-loading-space-vario-floor>
  </div>
}
@if (isPalletStacking) {
  <div class="tabContent">
    <gl-loading-space-pallet-stacking
      (submitEvent)="submitEvent($event, 'PalletStacking')"
      [isEdit]="isEdit"
      [loadingSpace]="loadingSpace"
      [chosenLoadingSpace]="chosenLoadingSpace"
    ></gl-loading-space-pallet-stacking>
  </div>
}
@if (isPalletVehicleLoading) {
  <div class="tabContent">
    <gl-loading-space-pallet-vehicle-loading
      (submitEvent)="submitEvent($event, 'PalletVehicle')"
      [isEdit]="isEdit"
      [loadingSpace]="loadingSpace"
      [chosenLoadingSpace]="chosenLoadingSpace"
    ></gl-loading-space-pallet-vehicle-loading>
  </div>
}
</gl-box>

@if (isEditMultistop) {
  <gl-multi-stop-edit
    [position]="getPosition()"
    [currentWorkSpaceId]="currentWorkSpaceId"
    [savedStops]="savedStops"
    (closeWindow)="openMultistop()"
    (submitStops)="submitStops($event)"
  ></gl-multi-stop-edit>
}
